import { styledStitches } from "@/app/design-system/styles/stitches.config";

export const Form = styledStitches("form", {
  display: "flex",
  flexDirection: "column",
  gap: 28,
});
